// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CustomerCodeService = {};

CustomerCodeService.getCustomerCodeList = function (userInput) {
  return lossClient({
    url: "/Customer/search?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CustomerCodeService;
